import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import Footer from "@/components/Footer";
import { APP_VERSION } from "@/lib/version";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Giriş başarılı. Yönlendiriliyorsunuz…");
      navigate("/dashboard");
    } catch (e) {
      const msg = formatApiErrorDetail(e.response?.data?.detail) || e.message;
      setError(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      {/* Hero */}
      <div className="hidden lg:block relative overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1621873129944-8d88a5328a0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxpc3RhbmJ1bCUyMGNpdHlzY2FwZSUyMG1vZGVybiUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODI5Mzk2ODB8MA&ixlib=rb-4.1.0&q=85"
          alt="Şehir manzarası"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-950/70" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-sm bg-red-600 flex items-center justify-center font-heading font-bold">T</div>
            <div>
              <div className="font-heading font-bold text-lg">Türk ADS CDN</div>
              <div className="text-[10.5px] uppercase tracking-[0.15em] text-slate-300">Merkezi Reklam Dağıtım Ağı</div>
            </div>
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-[0.2em] text-slate-300 mb-3">Kurumsal Çözümler</div>
            <h1 className="font-heading text-4xl sm:text-5xl font-bold leading-tight tracking-tight">
              Dijital Reklam Ağınızı<br/>Merkezi Olarak Yönetin
            </h1>
            <p className="mt-5 max-w-md text-slate-200 text-sm leading-relaxed">
              Anlaşmalı yayıncı ağınız için otomatik JS ve iframe entegrasyon kodları üretin;
              kampanya, mecra ve görsel süreçlerinizi tek bir panel üzerinden güvenle yönetin.
            </p>
          </div>
          <div className="text-[11px] text-slate-400 tracking-wider uppercase">
            v{APP_VERSION} · IQdsgn.com
          </div>
        </div>
      </div>

      {/* Form */}
      <div className="flex items-center justify-center px-6 py-12 bg-white">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8 flex items-center gap-3">
            <div className="w-10 h-10 rounded-sm bg-red-600 flex items-center justify-center text-white font-bold font-heading">T</div>
            <div className="font-heading font-bold text-slate-950 text-lg">Türk ADS CDN</div>
          </div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-slate-500 mb-2">Yönetici Girişi</div>
          <h2 className="font-heading font-bold text-3xl text-slate-950 tracking-tight">Sisteme Giriş</h2>
          <p className="text-sm text-slate-500 mt-2 mb-8">
            E-posta ve şifreniz ile Türk ADS CDN yönetim paneline erişin.
          </p>

          <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
            <div>
              <Label htmlFor="email" className="text-sm font-medium text-slate-900">E-posta Adresi</Label>
              <Input
                id="email"
                type="email"
                data-testid="login-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ornek@belediye.tr"
                required
                className="mt-1.5 rounded-sm"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-sm font-medium text-slate-900">Şifre</Label>
              <Input
                id="password"
                type="password"
                data-testid="login-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="mt-1.5 rounded-sm"
              />
            </div>

            {error && (
              <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-sm px-3 py-2" data-testid="login-error">
                {error}
              </div>
            )}

            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full bg-red-600 hover:bg-red-700 rounded-sm h-11 font-heading font-semibold tracking-wide uppercase text-xs"
            >
              {loading ? "Giriş Yapılıyor…" : "Giriş Yap"}
            </Button>
          </form>

          <Footer className="mt-10 pt-6 border-t border-slate-100" />
        </div>
      </div>
    </div>
  );
}
